<script setup>
  import { ref, computed, watchEffect } from 'vue';
  import { useMediaQuery } from '@/composables/useMediaQuery';
  import { useMapAdStore } from "@/stores/MapAdStore";
  import { useDetailPanelStore } from '@/stores/DetailPanelStore';
  import MapAdSlot from "@/components/MapAdSlot.vue";

  const mapAdStore = useMapAdStore();
  const detailPanelStore = useDetailPanelStore();

  const isDesktopXL = useMediaQuery('(min-width: 1600px)');

  const adContainer = ref(null);
  const translateAmount = ref(null);
  const translateSpeed = ref(500);
  const rightPanelOpen = ref(false);

  const imageURL = computed(() => {
    const randomImageNumber = Math.floor(Math.random() * 3 + 1);

    return `https://cdn-consumer.weatherflow.com/images/ads/tempest/tempest-300x250-${randomImageNumber}.webp`;
  });

  const hideAd = computed(() => !isDesktopXL.value && mapAdStore.blockingAdPanelOpen)

  function setRightPanelOpenValues(e) {
    const rightPanel = detailPanelStore.panelElement;    
    rightPanelOpen.value = true;  

    mapAdStore.blockingAdPanelOpen = true;  
    
    if (!isDesktopXL.value) return;
    
    const boundingBox = rightPanel.getBoundingClientRect();
    
    translateAmount.value = boundingBox.width + 8;
    translateSpeed.value = 500;
  }

  function setRightPanelCloseValues(e) {
    mapAdStore.blockingAdPanelOpen = false;
    rightPanelOpen.value = false;  
    translateAmount.value = 0;
  }

  watchEffect(() => {
    if (detailPanelStore.panelOpen && detailPanelStore.panelElement && isDesktopXL.value) {
      setRightPanelOpenValues();
    } else {
      setRightPanelCloseValues();
    }
  })

  watchEffect(() => {
    if (mapAdStore.blockingAdPanelOpen && !rightPanelOpen.value && isDesktopXL.value) {
      // TODO: Find a better way to determine translate amount for sheets that open on the right.
      // The source selector might not always be there.
      const secondarySheet = document.querySelector('.jwx-map__source-selector');
      const boundingBox = secondarySheet.getBoundingClientRect();
      translateAmount.value = boundingBox.width > 0 ? boundingBox.width + 16 : 330;
      translateSpeed.value = 250;
    }

    if (!mapAdStore.blockingAdPanelOpen) {
      translateAmount.value = 0;
    }
  })
</script>

<template>
  <div
    class="jwx-map__ad jwx-wrapper-block jwx-wrapper-block--transparent-border"
    :class="{'jwx-map__ad--blocked': mapAdStore.blockingAdPanelOpen}"
    :style="`--map-ad-translate: ${translateAmount}px; --map-ad-translate-speed: ${translateSpeed}`"
  >
    <MapAdSlot
      v-if="mapAdStore.adFilled"
      :style="{ display: hideAd ? 'none' : 'block'}"
      :adSlot="mapAdStore.currentAdSlot"
      :key="mapAdStore.currentAdSlot"
      ref="adContainer"  
    />
    <div 
      v-else
      class="jwx-map-ad"
      :style="{ display: hideAd ? 'none' : 'block'}"
      data-map="ads">
      <a href="https://shop.tempest.earth/products/tempest?utm_source=consumermap&utm_id=web.housead" target="_blank">
        <img :src="imageURL" alt="Tempest Weather Station" width="300px" height="250px">
      </a>
    </div>
  </div>
</template>